
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Btn from "./Btn";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IHostManager } from "../../../../../services";

export interface ManagerModalProps {
    manager: IHostManager;
    onClose: () => void;
}

function ManagerModal({ manager: m, onClose }: ManagerModalProps) {

    const labels = i18nManager.Labels.about;
    const info: [string, string | undefined][] = [
        [labels.role, m.display_role ?? m.role],
        [labels.country, m.settings?.country],
        [labels.region, m.settings?.state_region],
    ];

    React.useEffect(() => {
        const handler = (e: KeyboardEvent) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [onClose]);

    return (<div className={styles["modal-overlay"]} onClick={(e) => e.target === e.currentTarget && onClose()}>
        <div className={styles["modal"]} role="dialog" aria-label={m.display_name}>
            <button className={styles["modal-close"]} onClick={onClose} aria-label="Close"><i className="fa fa-xmark" /></button>
            <div className={styles["modal-media"]}>
                <img src={m.half_body_picture_url || m.passport_picture_url} alt={m.display_name} />
            </div>
            <div className={styles["modal-body"]}>
                <span className={styles["chip"]}><i className="fa fa-circle" style={{ fontSize: "0.5em", verticalAlign: "middle", color: "var(--green)" }} /> {labels.active}</span>
                <h2 className={styles["h-04"]}>{m.display_name}</h2>
                {m.profile_details && (<p className={styles["lead"]}>{m.profile_details}</p>)}
                <dl className={styles["facts"]}>
                    {info.filter(([_, v]) => !!v).map(([k, v]) => (<div key={k}>
                        <dt className={styles["tag"]}>{k}</dt>
                        <dd>{v}</dd>
                    </div>))}
                </dl>
                {Object.keys(m.social_accounts ?? {}).length > 0 && (<>
                    <span className={styles["tag"]}>{labels.socials}</span>
                    <div className={styles["chips"]} style={{ marginTop: 10 }}>
                        {Object.entries(m.social_accounts).map(([social, username]) => (
                            <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username)} className={styles["chip"]}>
                                <i className={Utils.getSocialIcon(social) ?? "fa fa-link"} /> {username}
                            </ReactRouterDom.NavLink>
                        ))}
                    </div>
                </>)}
                {m.settings?.show_link_to_profile && (<div style={{ marginTop: 28 }}>
                    <Btn size="sm" variant="outline" target="_blank" href={`${window.location.origin}/me/${m.member_id}`}>{labels.view_profile}</Btn>
                </div>)}
            </div>
        </div>
    </div>);
}

export default ManagerModal;
